import React from "react"
import { Box, Grid, makeStyles, SvgIcon, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import RoundedButton from "../../../../components/Actions/RoundedButton"
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import MainContainer from "../../../../components/Structure/Layouts/MainContainer";


const styles = makeStyles(theme => ({
    root: {
        color: 'white',
        position: 'relative',
        paddingTop: 80,
        paddingBottom: 80,
    },
    container: {
        position: 'relative',
    },
    title: {
        fontSize: 36,
        fontWeight: 600
    },
    description: {
        fontSize: 16,
        fontWeight: 500,
        '& span': {
            color: theme.palette.secondary.dark
        }
    },
    banner: {
        top: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        position: 'absolute',
        filter: 'brightness(0.5)'
    },
    buttons: {
        width: 270,
        height: 'auto',
        [theme.breakpoints.only('xs')]: {
            width: '100%'
        }
    }
}))

const InterestBanner = ({ history, content, onShowContactDrawer }) => {

    const classes = styles()

    return (
        <div className={classes.root}>
            <img src={content.banner} className={classes.banner} />
            <MainContainer className={classes.container}>
                <Grid container justifyContent='space-between' alignItems='center' spacing={4}>
                    <Grid item xs={12} md={6}>
                        <Grid container spacing={1}>
                            <Grid item>
                                <Typography className={classes.title} >
                                    {content.title}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography align='justify' className={classes.description}>
                                    {content.description}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <Grid container alignItems='center' spacing={1}>
                            <Grid item xs={12}>
                                <RoundedButton
                                    fullWidth
                                    onClick={onShowContactDrawer}
                                >
                                    {content.buttons.getin_touch.label}
                                </RoundedButton>
                            </Grid>
                            <Grid item xs={12}>
                                <RoundedButton
                                    fullWidth
                                    color='transparent_white_square'
                                    onClick={() => history.push(content.buttons.know_more.url)}
                                    endIcon={<ArrowForwardIosIcon />}
                                >
                                    {content.buttons.know_more.label}
                                </RoundedButton>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </MainContainer>
        </div >
    )
}

export default InterestBanner